import styled from 'styled-components';
import { Colors } from '~/config/Colors';

export const PieChartContainer = styled.div`
  position: relative;
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;

  /* @media (max-width: 1450px) {
    display: flex;
    align-items: center;
    justify-content: center;
  } */
`;

export const Total = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  align-items: center;

  font-size: 0.8em;
  font-weight: 600;
  color: ${Colors.Color14};
  line-height: 1.2em;
`;
